import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import GetDiagnosisData from '../../../src/services/general/getDiagnosisData.api'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow } from '@coreui/react'
import ListView from '../../../src/components/shared/ListView'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import AccordianEditDelete from '../../../src/components/shared/AccordianEditDelete'
import DifferentialSuggestion from './DifferentialSuggestion'
import SaveQuestionProvider from '../../../src/services/general/saveQuestionsProvider.api'
import DisplayQuestionViewOnly from '../../../src/components/shared/DisplayQuestionViewOnly'
import './CustomFormBuilder.css'
import './HierarchyComponents.css'

const Diagnosisdata = () => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectedDiagnostic, setSelectedDiagnostic] = useState('')
  const [dataForSelectedDiagnostic, setDataForSelectedDiagnostic] = useState({
    'Diffrential Diagnosis': [],
    'General Plan Statements': [],
    'Assessment Suggestion': [],
    HPI: [],
    Subjective: [],
    Incident: [],
  })

  const [showModal, setShowModal] = useState(false) // to open the detail modal
  const [file, setFile] = useState([])

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let a = await GetDiagnosisData()
      let data = JSON.parse(a.d)
      setDiagnosisData(data?.Data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const [activeAlert, setActiveAlert] = useState(null)

  const handleInfoClick = (event, text, id) => {
    event?.stopPropagation?.()
    if (activeAlert?.id === id) return setActiveAlert(null)
    const rect = (event?.currentTarget || event?.target)?.getBoundingClientRect()
    if (!rect) return
    const isTop = rect.top > 120
    setActiveAlert({
      id,
      text: text || 'No description available',
      placement: isTop ? 'top' : 'bottom',
      top: isTop ? rect.top - 12 : rect.bottom + 12,
      left: rect.left + rect.width / 2,
    })
  }

  useEffect(() => {
    const dismiss = (e) => (!e.target?.closest?.('.accordion-edit-delete-theme__icon, .differential-suggestion-theme__icon, .pe-alert-popover') || e.key === 'Escape') && setActiveAlert(null)
    window.addEventListener('pointerdown', dismiss)
    window.addEventListener('scroll', () => setActiveAlert(null), true)
    return () => {
      window.removeEventListener('pointerdown', dismiss)
      window.removeEventListener('scroll', () => setActiveAlert(null), true)
    }
  }, [])

  const handleView = (item) => {
    setShowModal(true)
    setSelectedDiagnostic({
      name: item.Name,
      id: item.id,
      code: item.Code,
    })
  }

  const GetDiffrentialDiagnosis = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'differentialDiagnosis', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'Diffrential Diagnosis': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const GetAssessmentSuggestion = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'Assessment Suggestion': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const GetGeneralPlanStatements = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
      data = JSON.parse(data.d)?.Data || []
      // console.log("parse data", data)
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      if (data.length > 0) {
        let foundAccordionsForSelectedDiagnostic = await data.find((item) => item?.Data?.diagnosis?.label === selectedDiagnostic.name)
        if (foundAccordionsForSelectedDiagnostic) {
          setDataForSelectedDiagnostic((p) => ({
            ...p,
            'General Plan Statements': foundAccordionsForSelectedDiagnostic.Data?.accordions || [],
          }))
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const extractLinkedAssessments = (data) => {
    const processOptions = (options) =>
      options?.reduce((acc, option) => {
        if (option.linkedAssessment) {
          acc.push(...option.linkedAssessment)
        }
        if (option.linkedQuestion) {
          if (Array.isArray(option.linkedQuestion)) {
            option.linkedQuestion.forEach((nestedQuestion) => {
              acc.push(...processOptions(nestedQuestion.options))
            })
          } else if (typeof option.linkedQuestion === 'object') {
            acc.push(...processOptions(option.linkedQuestion.options))
          }
        }
        return acc
      }, []) || []
    return (
      data?.questionData?.reduce((acc, question) => {
        acc.push(...processOptions(question.options))
        return acc
      }, []) || []
    )
  }

  const fetchHPI = async () => {
    try {
      if (selectedDiagnostic?.id) {
        let formattedData = await SaveQuestionProvider('GET', '', 'HPI', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          const raw = JSON.parse(formattedData.d)?.Data?.[0]?.questionData
          setDataForSelectedDiagnostic((p) => ({ ...p, HPI: raw ? JSON.parse(raw).filter(Boolean) : [] }))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubjective = async () => {
    try {
      if (selectedDiagnostic?.id) {
        let formattedData = await SaveQuestionProvider('GET', '', 'FollowUp', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          const raw = JSON.parse(formattedData.d)?.Data?.[0]?.questionData
          setDataForSelectedDiagnostic((p) => ({ ...p, Subjective: raw ? JSON.parse(raw).filter(Boolean) : [] }))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchInjection = async () => {
    try {
      if (selectedDiagnostic?.id) {
        let formattedData = await SaveQuestionProvider('GET', '', 'incident', selectedDiagnostic.id?.toString(), '')
        if (formattedData) {
          const raw = JSON.parse(formattedData.d)?.Data?.[0]?.questionData
          setDataForSelectedDiagnostic((p) => ({ ...p, Incident: raw ? JSON.parse(raw).filter(Boolean) : [] }))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (selectedDiagnostic) {
      GetDiffrentialDiagnosis()
      GetGeneralPlanStatements()
      fetchHPI()
      fetchInjection()
      fetchSubjective()
      GetAssessmentSuggestion()
    }
  }, [selectedDiagnostic])

  const renderAccordions = (list, index) => {
    console.log(list)
    return (
      <div className=" ">
        <CRow>
          <div className="overflow-visible">
            {list?.map((item) => (
              <AccordianEditDelete
                title={item.title}
                accordion={item}
                // editAccordion={editAccordion}
                // deleteAccordion={deleteAccordion}
                isFirst={true}
                isViewOnly={true}
                setActiveDescriptions={() => { }}
                handleAddTitleDescription={(item, e) => handleInfoClick(e || window.event, item.description, item.id || item.title)}
                file={file}
                setFile={setFile}
                handleTitleParentMediaId={() => { }}
                content={
                  <div>
                    <div className="d-flex gap-2 justify-content-center" style={{ marginTop: '10px' }}>
                    </div>

                    {item.suggestions && (
                      <ul className="list-group mt-4 mx-4">
                        <DifferentialSuggestion
                          suggestions={item?.suggestions?.suggestionName}
                          parentId={item.id}
                          orders={item?.suggestions?.orders}
                          // onSuggestionsChange={handleSuggestionsChange}
                          // setSaveResoanChange={setSaveResoanChange}
                          // submitDescription={submitDescription}
                          // setSubmitDescription={setSubmitDescription}
                          setActiveDescriptions={() => { }}
                          handleAddStatementDescription={(item, descriptionText, e) => handleInfoClick(e || window.event, descriptionText, `${item.parentId}_${item.orderIndex || item.name}`)}
                          isStatementBox={false}
                          file={file}
                          setFile={setFile}
                          handleFileStatementData={() => { }}
                          handleStatementFileSave={() => { }}
                          isViewOnly={true}
                        />
                      </ul>
                    )}

                    {item.children.length > 0 && <div className="mt-4">{renderAccordions(item.children)}</div>}
                  </div>
                }
              />
            ))}
          </div>
        </CRow>
      </div>
    )
  }

  return (
    <>
      <div className="position-relative patient-theme-page diagnosis-data-theme">
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme" style={{ minHeight: '100vh', overflow: 'auto' }}>
          <CRow className="p-2">
            {diagnosisData.map((item, index) => {
              let dataStatus = false
              return (
                <CCol xs={4} key={index}>
                  <ListView
                    showMatch={false}
                    heading={`${item.Name}[${item.Code}]`}
                    viewFunc={() => handleView(item)}
                    contentMatch={dataStatus.length > 0 ? true : false}
                  />
                </CCol>
              )
            })}
          </CRow>
        </div>
      </div>

      <CModal size="xl" scrollable onClose={() => setShowModal(false)} visible={showModal} className="patient-theme-modal diagnosis-data-theme__modal diagnosis-data-theme__detail-modal">
        <CModalHeader className="p-3" onClose={() => setShowModal(false)}>
          <CModalTitle>{selectedDiagnostic?.name || 'Diagnosis Details'}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="d-flex flex-column gap-4">
            {Object.entries(dataForSelectedDiagnostic).map(([key, value]) => {
              return (
                <div key={key}>
                  <CAccordion flush>
                    <CAccordionItem itemKey={1}>
                      <CAccordionHeader>{key}</CAccordionHeader>
                      <CAccordionBody>
                        {['HPI', 'Subjective', 'Incident'].includes(key) ? (
                          <div className="custom-form-builder-theme">
                            {value?.length > 0 ? (
                              <DisplayQuestionViewOnly fetchedQuestions={{ questionData: value }} />
                            ) : (
                              <div className="text-center py-2" style={{ color: 'var(--ui-text-secondary, #a1a1aa)' }}>No questions available</div>
                            )}
                          </div>
                        ) : (
                          renderAccordions(value)
                        )}
                      </CAccordionBody>
                    </CAccordionItem>
                  </CAccordion>
                </div>
              )
            })}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setShowModal(false)} className="ui-action-btn ui-action-btn--secondary">
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      {activeAlert &&
        typeof document !== 'undefined' &&
        createPortal(
          <div
            className={`pe-alert-popover pe-alert-popover--${activeAlert.placement}`}
            role="tooltip"
            style={{ top: activeAlert.top, left: activeAlert.left, zIndex: 2000 }}
          >
            <div className="pe-alert-popover__content">
              <span className="pe-alert-popover__content-icon" aria-hidden="true">
                i
              </span>
              <span>{activeAlert.text}</span>
            </div>
            <span className="pe-alert-popover__arrow" aria-hidden="true" />
          </div>,
          document.body,
        )}
    </>
  )
}

export default Diagnosisdata
